import axios from 'axios';
import { normalizeAccutradeCoreProductCode } from '../../utils/vmtShared';

const resolveSendEndpoint = (sendMode = 'general') => {
    if (sendMode === 'trade') {
        return '/api/vmt/send-trade';
    }
    return '/api/vmt/send';
};

export const normalizeVmtRecordsForSend = (records) => {
    if (!Array.isArray(records)) return records;
    return records.map((record) => {
        if (!record || typeof record !== 'object') return record;
        const normalizedProductCd = normalizeAccutradeCoreProductCode(record.productCd);
        if (normalizedProductCd === record.productCd) return { ...record };
        return { ...record, productCd: normalizedProductCd };
    });
};

export const sendVmtRecords = async ({ records, userEmail, sendMode = 'general' }) => {
    const payload = { records: normalizeVmtRecordsForSend(records) };
    if (userEmail) {
        payload.userEmail = userEmail;
    }
    const { data } = await axios.post(resolveSendEndpoint(sendMode), payload);
    return data;
};

export const sendVmtNullSubmission = async () => {
    const { data } = await axios.post('/api/vmt/send-null');
    return data;
};

export const getVmtSendHistory = async (options = {}) => {
    const params = {};
    if (options.bac) {
        params.bac = options.bac;
    }
    if (options.limit) {
        params.limit = options.limit;
    }
    const { data } = await axios.get('/api/vmt/send-history', { params });
    return data;
};

export const deleteVmtSendHistoryEntries = async (ids = []) => {
    const { data } = await axios.delete('/api/vmt/send-history', { data: { ids } });
    return data;
};
